module.exports = __webpack_public_path__ + "media/images/pen_hotpink-7ee4b3bf.png";